module.exports = __webpack_public_path__ + "img/10_of_Diamonds.svg.2e6707c6.png";